'use strict'

export default function setupStageBudget(stage,labels) {
  let lookupInBudget=(budget,element,field)=>{
    let item=budget!==undefined ? budget.filter(item=>item.id===element)[0] : undefined;
    return item!==undefined ? item[field] : undefined;
  };

  let budget=[
    {
      id:"hours",
      element: labels!==undefined ? labels.hours : "hours",
      cost: stage.cost.hours!==null ? stage.cost.hours : undefined,
      tolerance: lookupInBudget(stage.budget,"hours","tolerance"),
      comment: lookupInBudget(stage.budget,"hours","comment")
    },
    {
      id:"expences",
      element: labels!==undefined ? labels.expences : "expences",
      cost: stage.cost.expences!==null ? stage.cost.expences : undefined,
      tolerance: lookupInBudget(stage.budget,"expences","tolerance"),
      comment: lookupInBudget(stage.budget,"expences","comment")
    },
    { id:"investment",
      element: labels!==undefined ? labels.investment : "investment",
      cost: stage.cost.investment!==null ? stage.cost.investment : undefined,
      tolerance: lookupInBudget(stage.budget,"investment","tolerance"),
      comment: lookupInBudget(stage.budget,"investment","comment")
    },
    {
      id: "total",
      element: labels!==undefined ? labels.total : "total",
      cost: stage.cost.sum!==null ? stage.cost.sum : undefined,
      tolerance: stage.cost.tolerance!==undefined ? stage.cost.tolerance : undefined,
      comment: lookupInBudget(stage.budget,"total","comment")
    }
  ]
  return budget;
}



// WEBPACK FOOTER //
// ./views/plan/setupStageBudget.js